import script from "./segment-selector-lite.vue?vue&type=script&setup=true&lang=ts"
export * from "./segment-selector-lite.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__